/**
 * Desktop may create a browser. Remote clients may only reopen a tab the
 * desktop host already reported for this thread.
 */
export function isBrowserSurfaceAvailable(input: {
  readonly desktopHost: boolean;
  readonly tabId: string | null | undefined;
}): boolean {
  return input.desktopHost || input.tabId != null;
}

/**
 * The preview panel is not the owner of a tab while it is watched remotely or
 * while another client has taken control of it.
 */
export function shouldClosePreviewSessionOnSurfaceClose(input: {
  readonly desktopHost: boolean;
  readonly remoteControlled: boolean;
}): boolean {
  return input.desktopHost && !input.remoteControlled;
}
